var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "pencilTitle"
  }, "Pencil") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "pencilTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.7 33.2-5.7 14.8 14.8-5.7 23.2-23.1-9.2-9.2-23.1 23.2zm8 7.4-10.2 3.9 3.9-10.3 21.4-21.4 6.3 6.3-21.4 21.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m46.1 1.9c-1.2-1.2-2.8-1.9-4.6-1.9-1.7 0-3.4 0.7-4.6 1.9l-4.9 4.9 9.2 9.2 4.9-4.9c2.5-2.6 2.5-6.7 0-9.2m-1.4 7.8-3.5 3.5-6.3-6.3 3.5-3.5c0.8-0.8 2-1.3 3.2-1.3s2.3 0.5 3.2 1.3c1.6 1.7 1.6 4.5-0.1 6.3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.3ade968b7887e18f12866e2cfcff2507.svg";
export { ForwardRef as ReactComponent };